import Vue from 'vue';
import { deepCopy, getCurrentIP, clearAllSignals, findPinBySignal, filterOptions, formatSize } from './utils';
import { configGpio } from './gpio';


export function spiChangeMode(state, modeName) {
    const currentIP = getCurrentIP(state);

    if (!currentIP) return;

    currentIP.mode = modeName;

    const instanceName = currentIP.instance;

    clearAllSignals(state, currentIP);

    if (modeName === 'Disable') {
        return;
    }

    resetConfigFields(state, currentIP, modeName);


    const config = state.config[currentIP.name];

    const mode = config.modes.find(m => m.name === modeName);

    if (mode) {
        for (const signal of mode.signals) {
            setPinSignal(state, currentIP, signal);
        }
    } else {
        console.log(`@`, `Sorry, modeName=${modeName} not support!`);
    }
    
}

export function spiChangeHardwareNssSignal({ state }, hardwareNssSignal) {

    const currentIP = getCurrentIP(state);

    if (!currentIP) return;

    const NSS = currentIP.fields.find(f => f.name === 'NSS');
    if (NSS) {
        const allOptions = [{
                    "value": "SPI_NSS_SOFT",
                    "label": "Software"
                },
                {
                    "value": "SPI_NSS_HARD_INPUT",
                    "label": "Input Hardware"
                },
                {
                    "value": "SPI_NSS_HARD_OUTPUT",
                    "label": "Output Hardware"
                }];
        NSS.options = allOptions.filter(item => item.value === hardwareNssSignal);
        NSS.value = NSS.options[0].value;
    }
}

export function spiChangeBaudRatePrescaler({ state }, baudRatePrescaler) {

    const currentIP = getCurrentIP(state);

    if (!currentIP) return;

    const calculateBaudRate = currentIP.fields.find(f => f.name === 'CalculateBaudRate');
    if (calculateBaudRate) {
        const max = calculateBaudRate.max;
        const index = baudRatePrescaler.lastIndexOf("_");
        const prescaler = parseInt(baudRatePrescaler.substring(index+1));
        const baudRate = max / prescaler;
        console.log(`baudRatePrescaler, index, prescaler , baudRate`, baudRatePrescaler, index, prescaler, baudRate)
        const baudRateString = formatSize(baudRate);
        calculateBaudRate.value = baudRateString;
    }
}

function setPinSignal(state, currentIP, _signal) {
    const signal = currentIP.instance + '_' + _signal;

    const pin = findPinBySignal(state.chip.pins, signal);

    // console.log(`signal`, signal, pin);

    if (pin) {

        // state.chip.pins 中为引脚修改状态
        Vue.set(pin, 'signal', signal);
        Vue.set(pin, 'ip', currentIP.instance);

        const pinCopy = configPin(state, pin, _signal)
        currentIP.pins.push(pinCopy);
    }
}

function resetConfigFields(state, currentIP, modeName) {

    const config = state.config[currentIP.name];

    const mode = config.modes.find(m => m.name === modeName);
    const fields = [];

    for (const p of mode.parameters) {
        let field = config.parameters.find(_p => _p.name === p.name);
        if (field) {
            field = deepCopy(field);
            if (p.options) {
                field.options = filterOptions(field.options, p.options);
            }

            if (p.value) {
                field.value = p.value;
            } else if (field.default) {
                field.value = field.default
            }

            // console.log(field.value)

            if (p.hasOwnProperty('visible')) {
                field.visible = p.visible
            }

            fields.push(field);
        } else {
            console.warn(`spi field not found: ${p.name}`)
            fields.push(deepCopy(p))
        }
    }

    Vue.set(currentIP, 'fields', fields);
}


function configPin(state, _pin, _signal) {

    const spi = state.config['SPI'];
    if (spi) {
        const signal = spi.signals.find(s => s.name === _signal);
        if (signal) {
            const pinCopy = configGpio(state, _pin, signal.mode)
            return pinCopy;
        }
    }
}